<template>
	<div class="each-scene">
		<div class="left-zone">
			<img :src="item.img" class="scene-img img-responsive" @error.once="__change__no__image" />
		</div>
		<div class="right-zone">
			<p v-text="item.name" class="title text-overflow"></p>
			<div class="tags" v-if="item.tags">
				<div class="tag" v-for="(tag,i) of item.tags" :key="i" v-text="tag" v-show="tag!=''"></div>
			</div>
			<p class="address" v-if="item.address">
				<img class="address-icon" :src="addressIcon" />
				<span class="detail-address text-overflow" v-text="item.address"></span>
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "ListOfScene",
	// inheritAttrs: false,
	props: {
		item: Object
	},
	data() {
		return {
			addressIcon: ""
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		this.addressIcon = API.ossUrl + "scene/png/address-icon.png";
	},
	destroyed() {},
	methods: {}
};
</script>


<style scoped lang="scss">
.each-scene {
	display: flex;
    align-items: center;
	padding: 0.24rem 0.4rem;
	.left-zone {
        display: flex;
        align-items: center;
        justify-content: center;
		width: 3.04rem;
		height: 3.04rem;
		border: 0.053333rem solid rgba(255, 188, 0, 1);
		border-radius: 0.266667rem;
        box-sizing: border-box;
		.scene-img {
            display: block;
			width: 2.933333rem;
			height: 2.96rem;
			border-radius: 0.213333rem;
		}
	}
	.right-zone {
		width: 6.213333rem;
        height: 2.613333rem;
		padding: 0.266667rem;
		box-sizing: border-box;
		background: rgba(255, 188, 0, 0.03);
		border: 0.026667rem solid rgba(255, 219, 117, 1);
		border-top-right-radius: 0.266667rem;
		border-bottom-right-radius: 0.266667rem;
		border-left: 0;
		.tags {
			width: 100%;
			display: flex;
			flex-wrap: nowrap;
			margin-top: 0.133333rem;
			margin-bottom: 0.4rem;
			min-height: 0.56rem;
			.tag {
				margin-right: 0.2133rem;
				padding: 0 0.266667rem;
				font-size: 0.32rem;
				font-family: PingFang SC;
				font-weight: 400;
				line-height: 0.453333rem;
				color: rgba(77, 77, 174, 1);
				flex: 0 0 auto;
				height: 0.56rem;
				border-radius: 0.16rem;
				display: flex;
				align-items: center;
				justify-content: center;
				border: 0.026667rem solid rgba(77, 77, 174, 1);
			}
		}
		.title {
			font-size: 0.426667rem;
			font-family: PingFang SC;
			font-weight: bold;
			line-height: 0.586667rem;
			color: rgba(51, 51, 51, 1);
		}
		.address {
			display: flex;
			width: 100%;
			margin: 0.2667rem 0 0rem;
			align-items: flex-start;
			.address-icon {
				margin-top: 0.026667rem;
                width: 0.32rem;
				height: 0.32rem;
			}
			.detail-address {
				width: 7.733333rem;
				font-size: 0.32rem;
				font-family: PingFang SC;
				font-weight: 400;
				line-height: 0.453333rem;
				color: rgba(102, 102, 102, 1);
			}
		}
	}
	.address {
		color: #808080;
		font-size: 12px;
	}
}
</style>

